import * as moment from 'moment';
import Moment = moment.Moment;
import 'moment/locale/da';

export class BasketLine {

    id: string;
    name: string;
    price: number;
    quantity: number;
    line_sum: number;
    product_data: any;

    static _JSONProps: string[] = [
        'id',
        'name',
        'price',
        'quantity',
        'product_data',
        'line_sum'
    ];

    constructor(initializer?: BasketLineInterface) {
        if (initializer === undefined) {
            return;
        }
    }

    static fromJSON(json: BasketLineInterface | string): BasketLine {
        if (json === null) {
            return new BasketLine();
        }

        if (typeof json === 'string') {
            return JSON.parse(json, BasketLine.reviver);
        } else {
            let task = Object.create(BasketLine.prototype);

            let extra = {};

            Object.keys(json).forEach((key, index) => {
                if (BasketLine._JSONProps.indexOf(key) !== -1) {
                    task[key] = json[key];
                }
            });

            return Object.assign(task, extra);
        }
    }

    static reviver(key: string, value: any): any {
        return key === "" ? BasketLine.fromJSON(value) : value;
    }

    public formattedDate(field: string, format: string) {
        if (this[field]) {
            let thisField: Moment = this[field];
            if (thisField.isValid()) {
                return this[field].format(format);
            }
        }
    }
}

// A representation of Token data that can be converted to
// and from JSON without being altered.
export interface BasketLineInterface extends BasketLine {
}
